import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
  type: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
});

export const settings = {
  copyableOptions: {
    relationsToCopy: ['externalReferences'],
  },
  variantProperties: [
    'cmsLanguageId',
    'seoTitle',
    'seoDescription',
    'seoImage',
    'cmsState',
    'description',
    'name',
    'shortName',
    'svgUrl',
  ],
};

export default class CategoryModel extends Model.extend(Validations) {
  @attr('string') connectLocalArtistId;
  @attr('string') connectLocalName;
  @attr('string') description;
  @attr('boolean') exclusiveForAudioplayers;
  @attr('number') mmcId;
  @attr('string') name;
  @attr('string') shortName;
  @attr('string') specialProperties;
  @attr('string') svgUrl;
  @attr('string') teaserText;
  @attr('string') type;

  // CMS fields
  @attr('string') seoTitle;
  @attr('string') seoDescription;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('external-reference', { async: true, inverse: null })
  externalReferences;
  @belongsTo('category', { async: true, inverse: null }) topCategory;
  @belongsTo('asset', { async: true, inverse: null }) seoImage;
  @belongsTo('trade-partner', { async: true, inverse: null }) tradePartner;

  // Getter and setter
  get connectArtistInfo() {
    let name = this.connectLocalName;
    let id = this.connectLocalArtistId;

    if (!name) {
      return null;
    }

    return `${name} (${id})`;
  }

  get countryCode() {
    return this.shortName;
  }

  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    let suffix = ` (${this.shortName})`;
    return `${this.name}${this.shortName ? suffix : ''}`;
  }
}
